import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/Card";


const Data_table = [
  // {
  //   aCode: "",
  //   aGroup: "",
  //   aNumber: "",
  //   aName: "",
  //   group:"",
  //   metal:"",
  //   cPerson:"",
  //   cellNumber:"",
  //   msgMobileNum:"",
  //   panNumber:"",
  //   address:"",
  //   deliveryAdsress:"",
  //   openingCr:"",
  //   oCrWt:"",
  //   openingDr:"",
  //   oDrWt:"",
  //   dueDays:"",
  //   seal:"",
  //   tds:"",
  //   place:"",

  // },

  {
    aCode: "",
    aGroup: "",
    aNumber: "",
    aName: "",
    group: "",
    metal: "",
    cPerson: "",
    cellNumber: "",
    msgMobileNum: "",
    panNumber: "",
    address: "",
    deliveryAdsress: "",
    openingCr: "",
    oCrWt: "",
    openingDr: "",
    oDrWt: "",
    dueDays: "",
    seal: "",
    tds: "",
    place: "",

  },





];

const TableData = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose1 = () => setShow1(false);
  //const handleShow1 = () => setShow1(true);
  const handleShow1 = (data) => {
    setShow1(true);
    if (data == 'add') {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
  }
  const navigate = useNavigate();
  const BackToOrnamentRecepit = () => {
    navigate('../dashboard/table/TableDataTransactionHOMESALE');
  };


  return (
    <>
      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">HOME SALE Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>GOLD</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>SILVER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>DIAMOND</Form.Check.Label>
                        </div>
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Receipt No</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-md-8'>
                            <Form.Label>Party Name</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>
                        <div className='col-md-12 py-2'>
                          <Form.Label>Rec.Type</Form.Label>
                          <Form.Control type="text" placeholder="" />
                        </div>

                        <div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Rec. Date</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-md-8'>
                            <Form.Label>Bill Date</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Branch</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-md-6'>
                            <Form.Label>Bill Party</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>SMITH</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>DEALER</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input type="radio" className='me-2' />
                          <Form.Check.Label>OTHER</Form.Check.Label>
                        </div>
                      </div>

                      <div className='container-fluid py-4 '>
                        <div className='col-lg-12'>

                          <div className='row '>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Record No</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Bill No</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                          </div>

                          <div className='row '>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Due Days</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Due Date</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                          </div>

                          <div className='row '>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Bill Type</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Remarks</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                          </div>

                          <div className='row '>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Rq. No.</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>
                            <div className='col-lg-6 py-2'>
                              <Form.Label>Select No</Form.Label>
                              <Form.Control type="text" placeholder="" />
                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>
                  
                    <div className='col-lg-12'>
                      <Form.Label>Product</Form.Label>
                      <Form.Control type="text" placeholder="" />
                    </div>
                 

                  <div className='col-lg-12 py-2'>
                    <Form.Label>Sub Product</Form.Label>
                    <Form.Control type="text" placeholder="" />
                  </div>

                


                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid'>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Rec.Mode</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Pcs Rate</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>GrossWt</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Less Wt.</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Net Wt.</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Total Wt.</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Wastage</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Was / Gram</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Mc / Gram</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Mc / Pcs</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>MC. Value</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>


                      </div>


                    </div>
                  </div>

                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid'>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Touch</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Wastage</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>

                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Pure Wt.</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Stone Amount</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>


                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Other Charges</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>HallMark</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>


                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Total Amount</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Tag Type</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>


                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Order No.</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Dia Amount</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>


                        <div className='row '>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Pcs Amount</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                          <div className='col-lg-6 py-2'>
                            <Form.Label>Issue</Form.Label>
                            <Form.Control type="text" placeholder="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-4" >

                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                      <th>Rec.No</th>
                      <th>Product Name</th>
                      <th>Iteam Name</th>
                      <th>Purity</th>
                      <th>Pcs</th>
                      <th>GrossWt</th>
                      <th>MiscWt.</th>
                      <th>NetWt.</th>
                      <th>Was.Wt</th>
                      <th>Waste GM</th>
                      <th>Waste%</th>
                      <th>Mc Grm</th>
                      <th>Mc GRAM</th>
                      <th>MC / PCS</th>
                      <th>MC</th>
                      <th>Touch</th>
                      <th>Wastage</th>
                      <th>Pure Wt.</th>
                      <th>Stone Amt.</th>
                      <th>Other Charges</th>
                      <th>HallMark Charges</th>
                      <th>Total Amount</th>
                      <th>ORD/91.6</th>
                      <th>Order No</th>
                      <th>Pcs Rate</th>
                      <th>Pcs Amount</th>
                      <th>WMode</th>
                      <th>Mode</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                  </tbody>
                </Table>
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">


                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToOrnamentRecepit}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={BackToOrnamentRecepit}>Save</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
